import { Product } from '@@types'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useCartStore } from '@entities/Cart'
import { formatPriceAmount } from '@entities/Product/helpers'

import useCartComment from '@features/cart/hooks/useCartComment'



import Button from '@shared/ui/button'
import ImageWithBg from '@shared/ui/image-with-bg'
import Textarea from '@shared/ui/text-area'
import { formatPrice } from '@shared/uttils'


import styles from './CartCommentModal.module.scss'

interface CommentCartModalProps {
  data: Product;
  onClose?: () => void;
}

export default function CommentCartModal ({
  data,
  onClose,
}: CommentCartModalProps) {
  const { hasComment, updateProductComment, removeProductComment, getProduct } =
    useCartStore()
  const { closeCartCommentModal } = useCartComment()

  const initialComment = getProduct(String(data.id))?.comment ?? ''
  const [ comment, setComment ] = useState(initialComment)
  const { t: tf } = useTranslation('favorites')
  const { t: tc } = useTranslation('cart')
  const { t: tco } = useTranslation('common')

  useEffect(() => {
    setComment(initialComment)
  }, [ data.id, initialComment ])

  const handleSave = () => {
    const trimmed = comment.trim()

    if (trimmed) {
      updateProductComment(String(data.id), trimmed)
    }
    else {
      removeProductComment(String(data.id))
    }

    onClose?.()
    closeCartCommentModal()
  }

  const handleDelete = () => {
    setComment('')
    removeProductComment(String(data.id))
    closeCartCommentModal()
  }

  return (
    <div className={styles.root}>
      <div className={styles.root__top}>
        <ImageWithBg
          className={styles.root__img}
          src={data.preview?.url as string}
        />
        <h3 className={styles.root__name}>{data.name}</h3>
        <span className={styles.root__price}>
          {formatPrice(data.priceOffer.price)}{' '}
          <span>/ {formatPriceAmount({ priceOffer: data.priceOffer, t: tf })}</span>
        </span>
      </div>

      <Textarea
        className={styles.root__textarea}
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        placeholder={tc('product.commentPlaceholder')}
      />

      <div className={styles.root__actions}>
        <Button
          className={styles.root__button}
          onClick={handleSave}
          disabled={!comment}
          size="large"
        >
          {tco('save')}
        </Button>
        {hasComment(data.id) && (
          <Button
            className={styles.root__button}
            theme="secondary"
            onClick={handleDelete}
            disabled={!initialComment}
            size="large"
          >
            {tco('delComment')}
          </Button>
        )}
      </div>
    </div>
  )
}
